import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useCallback, useEffect, useState } from "react";
import { fetchUserBilling } from "../../api";
import { palette } from "../../themes/theme";
import PrimaryButton from "../../component/PrimaryButton";
import SecondaryButton from "../../component/SecondaryButton";

const rowsPerPageOptions = [10, 20, 30, 50, 100];

const TableHeader = styled((props) => <TableCell {...props} />)(() => ({
  background: "transparent",
  color: palette.text.white80,
}));
const TableBodyCell = styled((props) => <TableCell {...props} />)(() => ({
  color: palette.text.white,
}));

const BillingHistoryTab = () => {
  const [invoiceList, setInvoiceList] = useState({ count: 0, list: [] });

  const [paginationObject, setPaginationObject] = useState({
    currentPage: 0,
    rowsPerPage: rowsPerPageOptions[0],
    totalPages: Math.ceil(invoiceList.count / rowsPerPageOptions[0]),
    indexOfLastItem: rowsPerPageOptions[0],
    indexOfFirstItem: rowsPerPageOptions[0] - 1,
  });

  const paginate = (pageNumber) => {
    setPaginationObject((previousValue) => {
      return {
        ...previousValue,
        currentPage: pageNumber,
        totalPages: Math.ceil(invoiceList.count / previousValue.rowsPerPage),
        indexOfLastItem: pageNumber * previousValue.rowsPerPage,
        indexOfFirstItem: pageNumber * previousValue.rowsPerPage - 1,
      };
    });
  };

  const handleRowsPerPageChange = (event) => {
    setPaginationObject((previousValue) => {
      const rowsPerPage = parseInt(event.target.value, 10);
      return {
        ...previousValue,
        rowsPerPage: rowsPerPage,
        currentPage: 1,
        totalPages: Math.ceil(invoiceList.count / rowsPerPage),
        indexOfLastItem: 1 * rowsPerPage,
        indexOfFirstItem: rowsPerPage - 1,
      };
    });
  };

  const getUsersList = useCallback(async () => {
    const res = await fetchUserBilling({
      body: {
        page: paginationObject.currentPage,
        limit: paginationObject.rowsPerPage,
      },
    });
    if (!res) return;
    setInvoiceList({
      count: res.data.count,
      list: res.data.rows,
    });
    setPaginationObject((previousValue) => {
      return {
        ...previousValue,
        totalPages: Math.ceil(res.data.count / previousValue.rowsPerPage),
      };
    });
  }, [paginationObject.currentPage, paginationObject.rowsPerPage]);

  useEffect(() => {
    getUsersList();
  }, [getUsersList]);

  return (
    <Box sx={{ minHeight: "300px", height: "inherit" }}>
      {invoiceList && invoiceList.list.length > 0 ? (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <TableContainer>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableHeader>Payment Date</TableHeader>
                  <TableHeader>Subscription Name</TableHeader>
                  <TableHeader>Status</TableHeader>
                  <TableHeader>Amount</TableHeader>
                  <TableHeader>Invoice</TableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {invoiceList.list.map((invoice) => (
                  <TableRow key={invoice.id}>
                    <TableBodyCell>{invoice.paymentDate}</TableBodyCell>
                    <TableBodyCell>{invoice.invoices.planName}</TableBodyCell>
                    <TableBodyCell>{invoice.invoices.status}</TableBodyCell>
                    <TableBodyCell>${invoice.amount}</TableBodyCell>
                    <TableBodyCell>
                      {invoice.invoices &&
                      invoice.invoices.status === "paid" &&
                      invoice.invoices.invoiceUrl ? (
                        <SecondaryButton
                          variant="outlined"
                          title="Get Invoice"
                          onClick={() => {
                            window.open(invoice.invoices.invoiceUrl, "_blank");
                          }}
                        />
                      ) : (
                        <></>
                      )}
                    </TableBodyCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            sx={{ color: palette.text.white }}
            rowsPerPageOptions={rowsPerPageOptions}
            component="div"
            count={paginationObject.totalPages}
            rowsPerPage={paginationObject.rowsPerPage}
            page={paginationObject.currentPage}
            onPageChange={() => paginate(paginationObject.currentPage + 1)}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "inherit",
          }}
        >
          <Typography color="textDisabled" sx={{ fontSize: 15 }}>
            No record found
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default BillingHistoryTab;
